module.exports = __webpack_public_path__ + "img/5-3.17de2447.png";